<template>
    <el-row class="homeContainer product-box">
      <!--中间-->
        <!--左侧导航-->
        <aside>
          <p class="skill_info_aside" style="text-align: center;margin-bottom: 0;"><span :title="this.$store.state.clientName?this.$store.state.clientName:this.client_info.client_name" class="skill_name">{{ this.$store.state.clientName?this.$store.state.clientName:this.client_info.client_name }}</span> <span class="skill_online">{{ this.client_info.open_product_type }}</span></p>
          <el-menu router :default-active="$route.path+ '?client_id=' + client_id">
           <!-- <el-menu-item index="/productList" style="text-align: center">
              <span slot="title">产品列表</span>
            </el-menu-item>-->
            <el-menu-item class="bg-black" :index="'/proInfo?client_id='+client_id">
              <i class="iconfont icon-jibenxinxi"></i>
              <span slot="title">基本信息</span>
            </el-menu-item>
            <el-menu-item class="bg-black" :index="'/skillSetting?client_id='+client_id">
              <i class="iconfont icon-jinengpeizhi"></i>
              <span slot="title">技能商店</span>
            </el-menu-item>
              <el-menu-item class="bg-black" :index="'/qa?client_id='+client_id">
                  <i class="el-icon-service" id="qa-icon"></i>
                  <span slot="title">问答库</span>
              </el-menu-item>
            <el-menu-item class="bg-black" :index="'/sdk?client_id='+client_id">
              <i class="iconfont icon-xiazai"></i>
              <span slot="title">下载SDK</span>
            </el-menu-item>
            <!--<el-menu-item index="/skillInfo">-->
            <!--<span slot="title">技能详情</span>-->
            <!--</el-menu-item>-->
          </el-menu>
        </aside>

        <!--右侧内容区-->
        <section class="content-container">
          <div class="grid-content bg-purple-light">
            <el-col :span="24" class="content-wrapper">
              <transition name="fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </el-col>
          </div>
        </section>

    </el-row>
</template>
<script>
  import CommonMethods from '@/mixins/commonMethods'
  import qs from 'qs'
  import {proInfoApi, updateClientApi,checkProApi} from '@/api/hardIndex.js'
  export default {
    mixins: [
      CommonMethods
    ],
    data() {
      return {
        menu: [],
        client_id: '',
        client_info:''
      }
    },
    created() {
//        this.menuList()
      this.getClientId()
      this.proInfo()
    },
    methods: {
      getClientId () {
            this.client_id = this.$route.query.client_id
      },
      async proInfo () {
        let res = await proInfoApi(qs.stringify({'client_id': this.$route.query.client_id}))
        if (res.data.code == 200) {
          this.client_info = res.data.data.data
        } else {
          this.$message.error('获取基本信息失败')
        }
      },
//          menuList () {
//            let menuObj = this.$router.options.routes.filter(item => {
//              return item.path == '/product'
//            })
//            this.menu = menuObj[0].children
//            console.log(this.menu);
//          }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .homeContainer {
    position: relative;
    width: 100%;
    height: 100%;

    aside {
      position: fixed;
      left: 0;
      top: 60px;
      bottom: 0;
      width: 200px;
      background: #fbfbfb;
      border-right: 1px solid #f7f5f6;
      &::-webkit-scrollbar {
        display: none;
      }
      .el-menu {
        height: 100%;
        height: -moz-calc(100% - 80px);
        height: -webkit-calc(100% - 80px);
        height: calc(100% - 80px);
        border-radius: 0px;
        border-right: none;
        /*.el-menu-item{*/
        /*text-align: center;*/
        /*}*/
      }


      .skill_name{
        line-height: 60px;
        max-width: 100px;
        font-size: 16px;
        display: inline-block;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
      .skill_online{
        border-radius: 10px;
        border: 1px solid #0086ff;
        padding: 1px 3px;
        color: #0086ff;
        margin-left: 5px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .content-container {
      position: absolute;
      left: 230px;
      right: 0;
      top: 87px;
      margin-top: 27px;
      height: 100%;
      background: #fff;
      .grid-content {
        height: 100%;
      }
      .content-wrapper {
        height: 100%;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .el-menu-item.is-active.bg-black{
      color: #0086ff;

    }
  }
  .product-box{
    .el-submenu.is-opened{
      .el-submenu__title{
        color: #0086ff;
      }
    }
      #qa-icon{
          font-size: 16px;
          width:0;
          margin-right:15px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware/Product.vue